/**
 * @readonly
 * @enum {string}
 */
export const AddressColors = Object.freeze({
    NAVY: 'paleblue',
    STEEL_BLUE: 'brightblue',
    DEEP_SKY_BLUE: 'brightazure',
    DARK_CYAN: 'turquoise',
    DARK_GREEN: 'dullazure',
    LIME_GREEN: 'grassgreen',
    LIME_GREEN_200: 'brightpalegreen',
    AQUAMARINE: 'brightgreen',
    PURPLE: 'deeppurple',
    MAGENTA: 'brightpurple',
    FIREBRICK: 'darkred',
    TOMATO: 'brightorangehighlight',
    SIERRA: 'dullorange',
    ORANGE: 'brightorange',
    ORANGE_200: 'orangehighlight',
    YELLOW_OLD: 'khaki'
})
